import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import Text from "../components/Text";
import { toJpeg } from "html-to-image";
import download from "downloadjs";

const EditPage = () => {
  const [params] = useSearchParams();
  const [count, setCount] = useState(0);
  const memeRef = useRef();

  const addText = () => {
    setCount(count + 1);
  };

  const handleExport = () => {
    if (memeRef.current === null) return;

    toJpeg(memeRef.current, { quality: 0.95 })
      .then((dataUrl) => {
        download(dataUrl, "meme.jpeg");
      })
      .catch((err) => {
        console.error("Export failed:", err);
      });
  };

  return (
    <div>
      <div style={{width:"400px", border:"1px solid"}} ref={memeRef} className="meme mt-5 mb-5">
        <img src={params.get("url")} width="300px" alt="meme" />
        {Array(count)
          .fill(0)
          .map((_, index) => (
            <Text key={index} />
          ))}
      </div >
      <div className="d-flex  gap-3 mt-3">
  <Button onClick={addText}>Add text</Button>
  <Button variant="success" onClick={handleExport}>Save</Button>
  </div>
    </div>
  );
};

export default EditPage;
